import { NATIONALIZATION_FLOW } from "@/lib/brand";
import { ArrowDown, PackageOpen, ScanSearch, Wrench, Factory, CheckCircle2 } from "lucide-react";

const ICONS = [PackageOpen, ScanSearch, Wrench, Factory, CheckCircle2];

export const Nationalization = () => {
  return (
    <section
      id="nacionalizacao"
      data-testid="nationalization-section"
      className="relative py-24 lg:py-32 bg-white overflow-hidden"
    >
      {/* subtle blueprint bg */}
      <div
        className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(10,25,47,0.9) 1px, transparent 1px), linear-gradient(90deg, rgba(10,25,47,0.9) 1px, transparent 1px)",
          backgroundSize: "48px 48px",
        }}
        aria-hidden
      />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-5 reveal">
              <span className="divider-gold" />
              <span className="tracking-eyebrow text-gold">Nacionalização de Componentes</span>
            </div>
            <h2
              className="font-display text-4xl lg:text-5xl font-bold text-navy leading-[1.05] tracking-[-0.025em] reveal"
              data-testid="nationalization-title"
            >
              Menos dependência externa.
              <br />
              Mais autonomia operacional.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:pt-4">
            <p className="text-lg text-slate-600 leading-relaxed reveal">
              A <strong className="text-navy">Imporparts</strong> desenvolve soluções para substituir
              componentes importados por equivalentes nacionais de alta qualidade, reduzindo custos,
              prazos de aquisição e dependência do mercado externo — mantendo a confiabilidade e o
              desempenho operacional.
            </p>
          </div>
        </div>

        {/* Vertical flow */}
        <div className="grid lg:grid-cols-5 gap-4 lg:gap-3 relative">
          {NATIONALIZATION_FLOW.map((n, i) => {
            const Icon = ICONS[i];
            const isLast = i === NATIONALIZATION_FLOW.length - 1;
            return (
              <div
                key={n.step}
                data-testid={`nationalization-step-${i}`}
                className="relative reveal card-lift rounded-2xl border border-slate-200 bg-white p-6 lg:p-7"
                style={{ transitionDelay: `${i * 90}ms` }}
              >
                <div className="flex items-center gap-3 mb-5">
                  <div
                    className={`w-11 h-11 rounded-xl flex items-center justify-center ${
                      isLast ? "bg-gold text-white" : "bg-navy text-white"
                    }`}
                  >
                    <Icon className="w-5 h-5" />
                  </div>
                  <div className="text-xs tracking-[0.22em] uppercase font-semibold text-slate-400">
                    Etapa 0{i + 1}
                  </div>
                </div>
                <div className="font-display text-lg font-semibold text-navy leading-snug mb-2">
                  {n.step}
                </div>
                <p className="text-sm text-slate-600 leading-relaxed">{n.desc}</p>

                {/* Down arrow between cards (mobile) / right arrow (desktop) */}
                {!isLast && (
                  <div className="hidden lg:flex absolute -right-3 top-1/2 -translate-y-1/2 z-10 w-7 h-7 rounded-full bg-white border border-slate-200 items-center justify-center text-gold rotate-[-90deg]">
                    <ArrowDown className="w-3.5 h-3.5" />
                  </div>
                )}
                {!isLast && (
                  <div className="lg:hidden flex justify-center mt-4 text-gold">
                    <ArrowDown className="w-5 h-5" />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
